import CommonList from "../../../common/list";
import React, {useEffect, useState} from "react";
import {columns} from "./columns/columns";
import {deleteReportById, exportReportById, getListReport} from "../../../api/weightSlip";
import {getMe} from "../../../api/system/admin/user-account";
import moment from "moment";
import {useSearchParams} from "react-router-dom";
import ViewParent from "./modal/viewParent";
import FilterWeightStation from "./Filter";
import TableTitleNew from "../../../common/list/components/TableTitleNew";
import DG_Menu_Delete from "../../../common/menu/delete/Delete";
import {DownloadOutlined} from "@ant-design/icons";
import * as XLSX from "xlsx";
import * as XLSXStyle from "xlsx";
import * as FileSaver from 'file-saver';

const Report = () => {

    const [searchParams] = useSearchParams();
    const [dataSource, setDataSource] = useState()
    const [total, setTotal] = useState()
    const me = getMe();
    const [reload, setReload] = useState(false)
    const [visible, setVisible] = useState(false)
    const [id, setId] = useState()
    const [name, setName] = useState()
    const [databaseKey, setDatabaseKey] = useState()

    const mapData = (value) => {
        if (!value) {
            return [];
        }
        return value?.map((item) => {
            return {
                "Mã phiếu": item.maPhieu,
                "Khách hàng": item.khachHangCompare,
                "Tên hàng": item.tenHang,
                "Mã hàng": item.maHang,
                "Mã khách hàng": item.maKH,
                "Biển số xe": item.soXe,
                "Khối lượng có tải": item.coTai,
                "Khối lượng không tải": item.tareWeight,
                "Trọng lượng hàng": item.hang,
                "Ngày cân": moment(item.ngayCan).format("DD/MM/YYYY"),
                "Giờ có tải": moment(item.gioCoTai).format("HH:mm:ss"),
                "Giờ Không tải": moment(item.gioKTai).format("HH:mm:ss"),
                "Đơn giá": item.donGia,
                "Thành tiền": item.thanhTien,

            };
        });
    }
    const exportExcel = (datasource, nameXLSX) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        let dataArray = mapData(datasource)
        const ws = XLSX.utils.json_to_sheet(dataArray);
        ws["!cols"] = [{wch: 15}, {wch: 25}, {wch: 15}, {wch: 25}, {wch: 15},
            {wch: 25}, {wch: 25}, {wch: 25}, {wch: 25}, {wch: 25}, {wch: 25},
            {wch: 25}, {wch: 25}, {wch: 25}];
        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSXStyle.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, nameXLSX + fileExtension);

    }

    const onClick = (id, name) =>{
        exportReportById(id, "report").then(r => {
            exportExcel(r, name)
        })
            .catch(()=>{
                console.log("error")
            })
    }
    const mapDatasource = (data) => {
        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                ...item,
                createDate: moment(item.createDate).format("HH:mm:ss DD/MM/YYYY"),
                startDate: item.startDate ? moment(item.startDate).format("DD/MM/YYYY") : "",
                endDate: item.endDate ? moment(item.endDate).format("DD/MM/YYYY") : "",
                menu: <div className={"flex justify-end"}>
                    <DownloadOutlined style={{ fontSize: 18 }}
                                      className={"mr-5"}
                                      onClick={() => onClick(item.id, item.name)}/>
                    <DG_Menu_Delete id={item.id} onOk={handleOnDelete}/>
                </div>
            };
        });
    }

    useEffect(() => {
        getListReport(me.key, searchParams.get("weightStation"), searchParams.get("page"), searchParams.get("pageSize")).then(r => {
            setDataSource(mapDatasource(r.data))
            setTotal(r.totalPage)
        })
            .catch(() => {
            })
    }, [searchParams.get("page"), searchParams.get("pageSize"), searchParams.get("weightStation"), reload])

    const handleOnDelete = (id) => {
        deleteReportById(id).then(r => {
            setReload(!reload)
        })
            .catch(()=>{})
    }
    return (
        <div className={"h-full"}>
            <TableTitleNew
                title={"Danh sách báo cáo"}
                extra={<FilterWeightStation/>}
            />
            {
                dataSource && <CommonList
                    columns={columns}
                    totalCount={total}
                    dataSource={dataSource}
                    onRow={(record) => {
                        return {
                            onClick: () => {
                                setVisible(true)
                                setId(record.id)
                                setName(record.name)
                                setDatabaseKey(record.databaseKey)
                            }
                        }
                    }}
                />
            }

            <ViewParent id={id}
                        visible={visible}
                        name={name}
                        databaseKey={databaseKey}
                        onCancel={() => {
                            setVisible(false)
                            setId(undefined)
                            setName(undefined)
                            setDatabaseKey(undefined)
                        }}/>
        </div>
    )
}
export default Report
